import { __assign, __spreadArrays } from "tslib";
import { evaluateHierarchyConditions } from './evaluateHierarchyConditions';
import { extractLocalizedString } from './i18nLogic';
import { hasVariationSelectableChoices, IsCatalogItamAvailable, isDishOptionsValid, isDisptachTypeAvailable, isHiddenCatalogItem, isPlatformAvailable, } from './menuLogic';
import { calcOrderItemGrandTotal, isUniqueOrderItem } from './orderItemLogic';
import { UnavailabileVariationReason } from '..';
import { getPriceInCents, getSafeStringValue } from '../utils';
export function getCatalogDisplayableOrderItem(_a) {
    var _b, _c;
    var catalog = _a.catalog, orderItem = _a.orderItem, itemsHash = _a.itemsHash, locale = _a.locale, dispatchTime = _a.dispatchTime, platform = _a.platform, currency = _a.currency, dispatchType = _a.dispatchType, sectionHint = _a.sectionHint;
    var item = itemsHash[orderItem.itemId];
    var dishOptionsValidity = isDishOptionsValid({
        catalog: catalog,
        item: item,
        dispatchTime: dispatchTime,
        platform: platform,
        dispatchType: dispatchType,
        itemsHash: itemsHash,
    });
    var itemAavailablity = isItemAvailable(item, dispatchTime, platform, dispatchType);
    var itemHierarchyAavailablity = isItemHierarchyAvailable(catalog, item, dispatchTime, platform, dispatchType, sectionHint);
    var reasons = __spreadArrays(dishOptionsValidity.reasons, [
        itemAavailablity.reason,
        itemHierarchyAavailablity.reason,
    ]).filter(function (reason) { return !!reason; }); // filter undefined values
    var disabled = isReasonsExistsByFilter(reasons, [
        UnavailabileVariationReason.UnavailableDeliveryMethod,
        UnavailabileVariationReason.UnavailablePlatform,
        UnavailabileVariationReason.UnavailableTime,
    ]);
    var displayableDishOptions = getDisplayableCatalogVariations({
        orderItem: orderItem,
        itemsHash: itemsHash,
        locale: locale,
        currency: currency,
        dispatchTime: dispatchTime,
        platform: platform,
        dispatchType: dispatchType,
        disabled: disabled,
        catalog: catalog,
    });
    var variationsChoicesStrings = getVariationsChoicesStrings(displayableDishOptions, locale, currency);
    var variationsWithErrors = displayableDishOptions.filter(function (variation) { var _a; return ((_a = variation.error) === null || _a === void 0 ? void 0 : _a.hasEnoughSelectableChoices) === false; });
    var unavailabilityErrorReason = getUnavailabilityErrorReason(variationsWithErrors);
    var submitDisabled = reasons.length > 0 || Boolean(unavailabilityErrorReason);
    var errors = getItemErrorsReasons(itemAavailablity, itemHierarchyAavailablity);
    var itemPrice = Number((_b = item.price) === null || _b === void 0 ? void 0 : _b.value);
    return {
        id: item.id || '',
        title: item.name || '',
        subTitle: item.description || '',
        labels: ((_c = item.labels) === null || _c === void 0 ? void 0 : _c.values) || [],
        quantity: orderItem.count || 1,
        specialRequest: orderItem.comment || '',
        errors: errors,
        variations: displayableDishOptions,
        submitDisabled: submitDisabled,
        totalPrice: getDisplayablePrice(calcOrderItemGrandTotal(orderItem), locale, currency),
        price: itemPrice
            ? getDisplayablePrice(getPriceInCents(item.price), locale, currency)
            : '',
        variationsChoicesStrings: variationsChoicesStrings,
        isDishDeleted: !!item.archived,
        uniqueItemId: isUniqueOrderItem(orderItem)
            ? orderItem.uniqueItemId
            : undefined,
        unavailabilityErrorReason: unavailabilityErrorReason,
        hideSpecialRequest: item.acceptSpecialRequest === undefined
            ? item.acceptSpecialRequest
            : item.acceptSpecialRequest === false,
    };
}
function isReasonsExistsByFilter(reasons, unavailabileVariationReason) {
    return reasons.some(function (reason) { return unavailabileVariationReason.includes(reason); });
}
function getUnavailabilityErrorReason(variationsWithErrors) {
    var _a, _b, _c;
    if (variationsWithErrors.length > 0) {
        return variationsWithErrors.some(function (variation) { var _a, _b; return (_b = (_a = variation.error) === null || _a === void 0 ? void 0 : _a.reasons) === null || _b === void 0 ? void 0 : _b.includes(UnavailabileVariationReason.SoldOut); })
            ? UnavailabileVariationReason.SoldOut
            : (_c = (_b = (_a = variationsWithErrors[0].error) === null || _a === void 0 ? void 0 : _a.reasons) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : UnavailabileVariationReason.Unavailable;
    }
    return;
}
function getItemErrorsReasons(itemAavailablity, itemHierarchyAavailablity, filterReasons) {
    var itemHierarchyAavailablityAfterFilter = !filterReasons ||
        (itemHierarchyAavailablity.reason &&
            filterReasons.includes(itemHierarchyAavailablity.reason))
        ? itemHierarchyAavailablity.reason
        : undefined;
    var reasons = (itemAavailablity.reason
        ? itemHierarchyAavailablityAfterFilter &&
            itemAavailablity.reason !== itemHierarchyAavailablityAfterFilter
            ? [itemAavailablity.reason, itemHierarchyAavailablityAfterFilter]
            : [itemAavailablity.reason]
        : [itemHierarchyAavailablityAfterFilter]).filter(function (reason) { return !!reason; });
    var isSoldOut = reasons.some(function (reason) { return reason === UnavailabileVariationReason.SoldOut; });
    return getConditionReasons(isSoldOut ? [UnavailabileVariationReason.SoldOut] : reasons);
}
export function getDisplayableOrderItem(_a) {
    var menu = _a.menu, orderItem = _a.orderItem, itemsHash = _a.itemsHash, locale = _a.locale, dispatchTime = _a.dispatchTime, platform = _a.platform, currency = _a.currency, dispatchType = _a.dispatchType, sectionHint = _a.sectionHint;
    var item = itemsHash[orderItem.itemId];
    var conditionResult = evaluateHierarchyConditions({
        entity: item,
        menuRoot: menu,
        conditionParams: { dispatchTime: dispatchTime, platform: platform, dispatchType: dispatchType },
        sectionHint: sectionHint,
        itemsHash: itemsHash,
    });
    var displayableVariations = getDisplayableVariations({
        orderItem: orderItem,
        itemsHash: itemsHash,
        locale: locale,
        currency: currency,
        dispatchTime: dispatchTime,
        platform: platform,
        dispatchType: dispatchType,
        disabled: !conditionResult.result,
        menu: menu,
    });
    var variationsChoicesStrings = getVariationsChoicesStrings(displayableVariations, locale, currency);
    var isDishDeleted = checkIfDishIsOnlyInTrash(menu, orderItem.itemId);
    var variationsWithErrors = displayableVariations.filter(function (variation) { var _a; return ((_a = variation.error) === null || _a === void 0 ? void 0 : _a.hasEnoughSelectableChoices) === false; });
    var unavailabilityErrorReason;
    if (variationsWithErrors.length > 0) {
        unavailabilityErrorReason = variationsWithErrors.some(function (variation) { var _a, _b; return (_b = (_a = variation.error) === null || _a === void 0 ? void 0 : _a.reasons) === null || _b === void 0 ? void 0 : _b.includes(UnavailabileVariationReason.SoldOut); })
            ? UnavailabileVariationReason.SoldOut
            : UnavailabileVariationReason.Unavailable;
    }
    return {
        id: item.id,
        title: extractLocalizedString(item.title, locale),
        subTitle: extractLocalizedString(item.description, locale),
        labels: item.labels || [],
        quantity: orderItem.count || 1,
        specialRequest: orderItem.comment || '',
        errors: conditionResult.reasons,
        variations: displayableVariations,
        submitDisabled: !conditionResult.result || Boolean(unavailabilityErrorReason),
        totalPrice: getDisplayablePrice(calcOrderItemGrandTotal(orderItem), locale, currency),
        price: item.price ? getDisplayablePrice(item.price, locale, currency) : '',
        variationsChoicesStrings: variationsChoicesStrings,
        isDishDeleted: isDishDeleted,
        uniqueItemId: isUniqueOrderItem(orderItem)
            ? orderItem.uniqueItemId
            : undefined,
        unavailabilityErrorReason: unavailabilityErrorReason,
        hideSpecialRequest: item.hideSpecialRequest,
    };
}
function checkIfDishIsOnlyInTrash(menu, orderItemId) {
    // filter all the sections that include orderItemId
    var sectionsWithTheItem = menu.sections.filter(function (section) {
        var _a, _b;
        return ((_a = section.itemIds) === null || _a === void 0 ? void 0 : _a.includes(orderItemId)) || ((_b = section.children) === null || _b === void 0 ? void 0 : _b.some(function (s) { var _a; return (_a = s.itemIds) === null || _a === void 0 ? void 0 : _a.includes(orderItemId); }));
    });
    return (sectionsWithTheItem.length === 1 && sectionsWithTheItem[0].id === 'trash');
}
function checkIfDishIsOnlyInArchived(catalog, orderItemId) {
    var itemSections = catalog.sections.filter(function (section) { var _a, _b; return (_b = (_a = section.itemIds) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.includes(orderItemId); });
    var itemArchivedSections = itemSections
        .filter(function (section) { return section.archived; })
        .map(function (s) { return s.id; });
    var itemSectionsIds = itemSections.map(function (s) { return s.id; });
    var itemArchivedMenus = catalog.menus.filter(function (menu) {
        var _a, _b;
        return ((_b = (_a = menu.sectionIds) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.some(function (sectionId) {
            return itemSectionsIds.includes(sectionId);
        })) && menu.archived;
    });
    return itemArchivedSections.length > 0 || itemArchivedMenus.length > 0;
}
function isItemHierarchyAvailable(catalog, item, dispatchTime, platform, dispatchType, sectionId) {
    var _a;
    var section = catalog.sections.find(function (s) { return s.id === sectionId; }) ||
        getSectionByItem(catalog, (_a = item.id) !== null && _a !== void 0 ? _a : '');
    if (!section) {
        if (sectionId) {
            console.log('section not found for item', {
                sectionId: sectionId,
                itemId: item.id,
            });
        }
        return {
            available: true,
        };
    }
    var sectionAvailability = isBaseItemAvailable(section, dispatchTime, platform, dispatchType);
    if (sectionAvailability.available) {
        var menu = catalog.menus.find(function (m) { return m.id === section.menuId; });
        if (menu) {
            return isBaseItemAvailable(menu, dispatchTime, platform, dispatchType);
        }
    }
    return sectionAvailability;
}
export function isDishOptionHierarchyAvailable(catalog, item, dispatchTime, platform, dispatchType, sectionId) {
    var _a;
    var section = catalog.sections.find(function (s) { return s.id === sectionId; }) ||
        getSectionByItem(catalog, (_a = item.id) !== null && _a !== void 0 ? _a : '');
    // dish option is not linked to an item
    if (!section) {
        return {
            available: true,
        };
    }
    var sectionAvailability = isBaseItemAvailable(section, dispatchTime, platform, dispatchType);
    if (sectionAvailability.available) {
        var menu = catalog.menus.find(function (m) { return m.id === section.menuId; });
        if (menu) {
            return isBaseItemAvailable(menu, dispatchTime, platform, dispatchType);
        }
    }
    return sectionAvailability;
}
export function getSectionByItem(catalog, itemId) {
    return catalog.sections.find(function (section) { var _a, _b; return (_b = (_a = section.itemIds) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.includes(itemId); });
}
export function isBaseItemAvailable(item, dispatchTime, platform, dispatchType) {
    if (!IsCatalogItamAvailable(item, dispatchTime)) {
        return {
            available: false,
            reason: UnavailabileVariationReason.UnavailableTime,
        };
    }
    if (!isDisptachTypeAvailable(item, dispatchType)) {
        return {
            available: false,
            reason: UnavailabileVariationReason.UnavailableDeliveryMethod,
        };
    }
    if (!isPlatformAvailable(item, platform)) {
        return {
            available: false,
            reason: UnavailabileVariationReason.UnavailablePlatform,
        };
    }
    if (isHiddenCatalogItem(item, dispatchType, platform)) {
        return {
            available: false,
            reason: UnavailabileVariationReason.Unavailable,
        };
    }
    return { available: true };
}
export function isItemAvailable(item, dispatchTime, platform, dispatchType) {
    if (item.inStock === false) {
        return { available: false, reason: UnavailabileVariationReason.SoldOut };
    }
    return isBaseItemAvailable(item, dispatchTime, platform, dispatchType);
}
function getDisplayableVariationType(variation) {
    return variation.minNumAllowed === 1 && variation.maxNumAllowed === 1
        ? 'variation.radio'
        : 'variation.checkbox';
}
function getClientSideId(variationPath, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var result = "variation-" + variationPath
        .map(function (crumb) { return crumb.value; })
        .join('-');
    if (suffix) {
        return result + '-' + suffix;
    }
    else {
        return result;
    }
}
function getDisplayableCatalogVariations(_a) {
    var _b;
    var orderItem = _a.orderItem, itemsHash = _a.itemsHash, _c = _a.initialVariationsPath, initialVariationsPath = _c === void 0 ? [] : _c, locale = _a.locale, currency = _a.currency, dispatchTime = _a.dispatchTime, platform = _a.platform, dispatchType = _a.dispatchType, disabled = _a.disabled, catalog = _a.catalog;
    return (((_b = orderItem.variations) === null || _b === void 0 ? void 0 : _b.map(function (v, index) {
        var _a;
        var choices = (_a = orderItem.variationsChoices) === null || _a === void 0 ? void 0 : _a[index];
        var variationPath = __spreadArrays(initialVariationsPath, [
            { type: 'index', value: index },
        ]);
        var displayableVariation = getDisplayableVariation(v, variationPath, choices, itemsHash, locale, currency, dispatchTime, platform, dispatchType, undefined, catalog, disabled);
        return displayableVariation;
    })) || []);
}
function getDisplayableVariations(_a) {
    var _b;
    var orderItem = _a.orderItem, itemsHash = _a.itemsHash, _c = _a.initialVariationsPath, initialVariationsPath = _c === void 0 ? [] : _c, locale = _a.locale, currency = _a.currency, dispatchTime = _a.dispatchTime, platform = _a.platform, dispatchType = _a.dispatchType, disabled = _a.disabled, menu = _a.menu;
    return (((_b = orderItem.variations) === null || _b === void 0 ? void 0 : _b.map(function (v, index) {
        var _a;
        var choices = (_a = orderItem.variationsChoices) === null || _a === void 0 ? void 0 : _a[index];
        var variationPath = __spreadArrays(initialVariationsPath, [
            { type: 'index', value: index },
        ]);
        var displayableVariation = getDisplayableVariation(v, variationPath, choices, itemsHash, locale, currency, dispatchTime, platform, dispatchType, menu, undefined, disabled);
        return displayableVariation;
    })) || []);
}
function isVariationValid(variation, choices) {
    var min = variation.minNumAllowed || 0;
    var max = variation.maxNumAllowed || 99999;
    return isOptionValid(min, max, choices);
}
function isOptionValid(minNumAllowed, maxNumAllowed, choices) {
    return choices.length >= minNumAllowed && choices.length <= maxNumAllowed;
}
export function getDisplayableVariation(variation, variationPath, choices, itemsHash, locale, currency, dispatchTime, platform, dispatchType, menu, catalog, disabled) {
    if (choices === void 0) { choices = []; }
    var error = menu
        ? hasVariationSelectableChoices({
            menu: menu,
            variation: variation,
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
            itemsHash: itemsHash,
        })
        : getCatalogItemErrors({
            variation: variation,
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
            itemsHash: itemsHash,
        });
    return {
        type: getDisplayableVariationType(variation),
        title: extractLocalizedString(variation.title, locale),
        fullTitle: extractLocalizedString(variation.title, locale),
        limitation: getVariationLimitation(variation),
        min: variation.minNumAllowed || 0,
        max: variation.maxNumAllowed || 99999,
        isValid: isVariationValid(variation, choices),
        variationPath: variationPath,
        clientSideId: getClientSideId(variationPath),
        choices: getDisplayableChoices(variation, choices, itemsHash, variationPath, locale, currency, dispatchTime, platform, dispatchType, menu, catalog) || [],
        disabled: !!disabled,
        error: error,
    };
}
function getCatalogItemErrors(_a) {
    var variation = _a.variation, dispatchTime = _a.dispatchTime, platform = _a.platform, dispatchType = _a.dispatchType, itemsHash = _a.itemsHash;
    var choicesWithoutErrors = variation.itemIds.filter(function (itemId) {
        var item = itemsHash[itemId];
        var itemAvailability = isItemAvailable(item, dispatchTime, platform, dispatchType);
        return itemAvailability.available;
    });
    var min = variation.minNumAllowed || 0;
    var hasEnoughSelectableChoices = min <= choicesWithoutErrors.length;
    if (!hasEnoughSelectableChoices) {
        var errors = variation.itemIds
            .map(function (itemId) {
            var item = itemsHash[itemId];
            var itemAvailability = isItemAvailable(item, dispatchTime, platform, dispatchType);
            return itemAvailability.reason;
        })
            .filter(function (err) { return err; });
        var reasons = errors.find(function (err) { return err === UnavailabileVariationReason.SoldOut; })
            ? [UnavailabileVariationReason.SoldOut]
            : errors;
        return { hasEnoughSelectableChoices: hasEnoughSelectableChoices, reasons: reasons };
    }
    return { hasEnoughSelectableChoices: hasEnoughSelectableChoices, reasons: undefined };
}
function getItemHashProps(itemsHash, itemId, locale) {
    var itemHash = itemsHash[itemId];
    if (itemHash.title) {
        return {
            title: extractLocalizedString(itemHash.title, locale),
            description: extractLocalizedString(itemHash.description, locale),
        };
    }
    else {
        var catalogItemHash = itemsHash[itemId];
        var name_1 = catalogItemHash.name, description = catalogItemHash.description;
        return {
            title: name_1,
            description: description,
        };
    }
}
function getDisplayableChoices(variation, choices, itemsHash, variationPath, locale, currency, dispatchTime, platform, dispatchType, menu, catalog) {
    if (choices === void 0) { choices = []; }
    return variation.itemIds.map(function (itemId) {
        var _a;
        var orderItem = choices.find(function (oi) { return oi.itemId === itemId; });
        var isSelected = Boolean(orderItem);
        var price = ((_a = variation.prices) === null || _a === void 0 ? void 0 : _a[itemId]) || 0;
        var item = itemsHash[itemId];
        var baseArguments = {
            item: item,
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
            itemsHash: itemsHash,
        };
        var getErrorsArgs = menu
            ? __assign(__assign({}, baseArguments), { menu: menu })
            : __assign(__assign({}, baseArguments), { catalog: catalog });
        var _b = getErrorsOfItemChoice(getErrorsArgs), errors = _b.errors, isDishDeleted = _b.isDishDeleted;
        var _c = getItemHashProps(itemsHash, itemId, locale), title = _c.title, description = _c.description;
        var result = {
            itemId: itemId,
            price: price,
            formattedPrice: price ? getDisplayablePrice(price, locale, currency) : '',
            title: getSafeStringValue(title),
            description: getSafeStringValue(description),
            clientSideId: getClientSideId(variationPath, itemId),
            isSelected: isSelected,
            isSelectable: errors.length === 0 && !isDishDeleted,
            variations: [],
            errors: errors,
            isDishDeleted: isDishDeleted,
        };
        if (orderItem) {
            var baseArgs = {
                orderItem: orderItem,
                locale: locale,
                currency: currency,
                dispatchTime: dispatchTime,
                platform: platform,
                dispatchType: dispatchType,
            };
            result.variations = menu
                ? getDisplayableVariations(__assign(__assign({}, baseArgs), { initialVariationsPath: __spreadArrays(variationPath, [
                        { type: 'itemId', value: itemId },
                    ]), itemsHash: itemsHash, menu: menu }))
                : catalog
                    ? getDisplayableCatalogVariations(__assign(__assign({}, baseArgs), { initialVariationsPath: __spreadArrays(variationPath, [
                            { type: 'itemId', value: itemId },
                        ]), itemsHash: itemsHash, catalog: catalog }))
                    : [];
        }
        return result;
    });
}
export function getVariationLimitation(variation) {
    var _a = variation.minNumAllowed, minNumAllowed = _a === void 0 ? 0 : _a, _b = variation.maxNumAllowed, maxNumAllowed = _b === void 0 ? 0 : _b;
    var min = minNumAllowed;
    var max = maxNumAllowed > 1000 ? 0 : maxNumAllowed;
    return getDisplayableLimitation(min, max);
}
function getDisplayableLimitation(min, max) {
    if (min === 0 && max === 0) {
        return null;
    }
    else if (min === 0 && max === 1) {
        return 'UP_TO_ONE';
    }
    else if (min === 0 && max > 1) {
        return 'UP_TO_MAX';
    }
    else if (min === 1 && max === 1) {
        return 'EXACTLY_ONE';
    }
    else if (min === 1 && max === 0) {
        return 'AT_LEAST_ONE';
    }
    else if (min > 1 && max === 0) {
        return 'AT_LEAST_MIN';
    }
    else if (min === max) {
        return 'EXACTLY';
    }
    else if (min >= 1 && max > 1) {
        return 'RANGE';
    }
    return null;
}
function getVariationsChoicesStrings(displayableVariations, locale, currency) {
    var result = [];
    displayableVariations.forEach(function (dv) {
        var tmp = [];
        dv.choices.forEach(function (c) {
            if (c.isSelected) {
                var price = c.price
                    ? " (" + getDisplayablePrice(c.price, locale, currency) + ")"
                    : '';
                tmp.push(c.title + price);
            }
            if (c.variations.length > 0) {
                tmp.push.apply(tmp, getVariationsChoicesStrings(c.variations, locale, currency));
            }
        });
        result.push(tmp.join(', '));
    });
    return result.filter(Boolean);
}
function getErrorsOfItemChoice(errorsOfChoiceArgs) {
    var item = errorsOfChoiceArgs.item, dispatchTime = errorsOfChoiceArgs.dispatchTime, platform = errorsOfChoiceArgs.platform, dispatchType = errorsOfChoiceArgs.dispatchType, itemsHash = errorsOfChoiceArgs.itemsHash;
    var menu = errorsOfChoiceArgs.menu;
    if (menu) {
        return getErrorsOfChoice({
            item: item,
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
            menu: menu,
            itemsHash: itemsHash,
        });
    }
    else {
        return getCatalogErrorsOfChoice({
            item: item,
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
            catalog: errorsOfChoiceArgs.catalog,
            itemsHash: itemsHash,
        });
    }
}
export function getErrorsOfChoice(_a) {
    var item = _a.item, dispatchTime = _a.dispatchTime, platform = _a.platform, dispatchType = _a.dispatchType, menu = _a.menu, itemsHash = _a.itemsHash;
    var conditionResult = evaluateHierarchyConditions({
        entity: item,
        menuRoot: menu,
        conditionParams: {
            dispatchTime: dispatchTime,
            platform: platform,
            dispatchType: dispatchType,
        },
        itemsHash: itemsHash,
    });
    return {
        errors: conditionResult.reasons,
        isDishDeleted: menu && item.id ? checkIfDishIsOnlyInTrash(menu, item.id) : false,
    };
}
function getUnavailabileVariationReasonToConditionReason() {
    var unavailabileVariationReasonToConditionReason = new Map();
    unavailabileVariationReasonToConditionReason.set(UnavailabileVariationReason.SoldOut, { type: 'order_delivery_time', reason: 'soldout' });
    unavailabileVariationReasonToConditionReason.set(UnavailabileVariationReason.UnavailableDeliveryMethod, { type: 'order_delivery_type' });
    unavailabileVariationReasonToConditionReason.set(UnavailabileVariationReason.UnavailablePlatform, { type: 'order_platform' });
    unavailabileVariationReasonToConditionReason.set(UnavailabileVariationReason.UnavailableTime, { type: 'order_delivery_time', reason: 'order_delivery_time' });
    unavailabileVariationReasonToConditionReason.set(UnavailabileVariationReason.Unavailable, { type: 'false' });
    return unavailabileVariationReasonToConditionReason;
}
export function getCatalogErrorsOfChoice(_a) {
    var item = _a.item, dispatchTime = _a.dispatchTime, platform = _a.platform, dispatchType = _a.dispatchType, catalog = _a.catalog, itemsHash = _a.itemsHash;
    var itemAvailability = isItemAvailable(item, dispatchTime, platform, dispatchType);
    var dishOptionsValidity = isDishOptionsValid({
        item: item,
        dispatchTime: dispatchTime,
        platform: platform,
        dispatchType: dispatchType,
        itemsHash: itemsHash,
    });
    dishOptionsValidity.isValid =
        dishOptionsValidity.isValid && itemAvailability.available;
    itemAvailability.reason &&
        dishOptionsValidity.reasons.push(itemAvailability.reason);
    return {
        errors: dishOptionsValidity.isValid
            ? []
            : getConditionReasons(dishOptionsValidity.reasons),
        isDishDeleted: catalog && item.id
            ? checkIfDishIsOnlyInArchived(catalog, item.id)
            : false,
    };
}
function getConditionReasons(reasons) {
    return reasons.map(function (reason) { return getConditionReason(reason); });
}
function getConditionReason(reason) {
    var unavailabileVariationReasonToConditionReason = getUnavailabileVariationReasonToConditionReason();
    var conditionReason = (unavailabileVariationReasonToConditionReason.get(reason) || 'false');
    return conditionReason;
}
export function getDisplayablePrice(price, locale, currency) {
    if (price === void 0) { price = 0; }
    var formattedLocale = locale.replace('_', '-');
    var numberFormat = new Intl.NumberFormat(formattedLocale, {
        style: 'currency',
        currency: currency,
    });
    return numberFormat.format(price / 100);
}
//# sourceMappingURL=displayableOrderItem.js.map